<template>
  <section id="about" class="styled__Section-cdr0cm-0 hLFcbT">
    <div
      class="Container-war86y-0 styled__Container-cdr0cm-2 vpjiZ"
      style="flex-grow: 0"
    >
      <div class="styled__Content-cdr0cm-3 cinBei">
        <div>
          <h2 class="Typography__H2-sc-1ii3pc8-0 dqtzN">About Our Ringtones</h2>
          <p
            class="Typography__Paragraph-sc-1ii3pc8-8 lgdcZX"
            style="text-align: left"
          >
            The ringtones are selected carefully with uniqueness and diversity:
            funny ringtones, baby ringtones, animals ringtones, message tones,
            pop, ringtones remix, rock, hip-hop, dance, rap, country...
          </p>
          <p
            class="Typography__Paragraph-sc-1ii3pc8-8"
            style="color: #000; text-align: left; margin: 16px 0"
          >
            Features:
          </p>
          <ul>
            <li class="li">
              Impressive collections with all various ringtones.
            </li>
            <li class="li">Set ringtones to enjoy them easily.</li>
            <li class="li">Super fast, lightweight and easy to use.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
ul {
  padding-left: 2rem;
}
.li {
  list-style: disc;
}
</style>
